module.exports = __webpack_public_path__ + "static/media/story-14.d3da7123.jpg";